module.exports = "pegasus_template/assets/themelp1/small/35.png";